import type { IProductBundleOption } from "@rogue/universal"
import type { BundleUIOption } from "../RuleTypes"
import type { IRogue, BuyRequest } from "@/js/services/RogueTypes"
import { findBundleProduct } from "@/js/pages/product/rackbuilder/utils/rackbuilder-util"

export function getOptionsForTrapBarBundle(rogue: IRogue, bundleOption: IProductBundleOption, options: BundleUIOption[], bundleBuyRequest: BuyRequest): BundleUIOption[] {
  // Both handle rows are titled "Handle:", so the second one is only distinguishable by being the optional one.
  if (bundleOption.isRequired || !String(bundleOption.title ?? '').toLowerCase().includes('handle')) {
    return options
  }

  const handleBrackets = String(findBundleProduct(rogue, bundleBuyRequest, 'frame', true)?.attributes?.edition ?? '')
  const isSingle = handleBrackets.toLowerCase() === 'single'

  // None is dropped on Dual so the second handle can't be deselected while two brackets ship.
  return options.filter(opt => isSingle ? !opt.value : Boolean(opt.value))
}
